import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';
import { getProductData } from '@elem/utils/getProductData';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import ProductNav from '../../common/ProductNav';
import { generalKey, productPageTheme } from '../../config/pageConfig';
import { useGlobal } from '@/utils/useGlobal';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';

export default function ExampleProductA() {
    const { gloproductlist } = useGlobal();
    const { locale } = useRouter();
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey });
    const [productDataA, setProductDataA] = useState<any>({});

    useEffect(() => {
        const getProductDataHandle = async () => {
            const productPageData = await getProductData(productMsg, locale, productMsg?.spuId || productMsg?.sourceId);
            setProductDataA(productPageData);
        };
        getProductDataHandle();
    }, []);
    return (
        <>
            <ProductNav activeTab={'Specs'} buyLink={productMsg.buyLink} />
            {productDataA.spuId && (
                <ProductSpecs productCatagory={productDataA.productCatagory} productDetail={productDataA.productDetail} theme={productPageTheme} />
            )}
        </>
    );
}
